<mat-card class="progress-card">
  <app-robot-thinking-face></app-robot-thinking-face>
  <div class="loader">
    <h2 class="title">AI Drafting in Progress</h2>
    <p class="message">
      Your document is currently being drafted by our AI agent. This process may take a few minutes depending on the
      complexity and length.
    </p>
  </div>
</mat-card>
